import { render, staticRenderFns } from "./AutomationIcon.vue?vue&type=template&id=55d11cbd&scoped=true"
import script from "./AutomationIcon.vue?vue&type=script&lang=js"
export * from "./AutomationIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d11cbd",
  null
  
)

export default component.exports